
export default {
  middleware: 'auth',
  auth: 'guest',

  async asyncData({ store }) {
    await store.dispatch('global/loadRegistrationSettings')
    await store.dispatch('global/loadLoginPageSettings')
  },

  head() {
    return {
      title: this.$t('register'),
    }
  },
}
